import {Component, OnInit} from '@angular/core';
import {TransportationService} from '../../api/transportation.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-segment-header',
  templateUrl: './segment-header.component.html',
  styleUrls: ['./segment-header.component.scss']
})
export class SegmentHeaderComponent implements OnInit {


  transport$: Observable<any>;
  zone$: Observable<any>;
  product$: Observable<any>;

  constructor(private transportationService: TransportationService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.transport$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.transportationService.getTransportation(params.get('transport')))
    );
    this.zone$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.transportationService.getProducts(params.get('transport'), params.get('zone')))
    );

    this.product$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.transportationService.getDetailsProduct(params.get('transport'), params.get('zone'), params.get('product')))
    );
  }


}
